import React, { Component, Fragment } from 'react';

import { Input, Row, Col, FormFeedback, Label } from 'reactstrap';

import PropTypes from 'prop-types';

import './styles.css';

class ParadigmaCheckBoxInput extends Component {
    constructor(props) {
        super(props);

        this.state = {

        }
    }

    static propTypes = {
        onChange: PropTypes.func,
        value: PropTypes.any,
        label: PropTypes.string,
        disabled: PropTypes.bool,

        labelDerecha: PropTypes.bool, // Muestra el label a la derecha del checkbox a menos que el mismo este alineado a la derecha
        //switchStyle
        switchStyle: PropTypes.bool, // Si es true se muestra con los estilos de un switch
        checkmarkOnSwitch: PropTypes.bool, // Mostrar un tilde en el check cuando el switch esta habilitado
        onlySwitch: PropTypes.bool, // Muestra solo el switch sin el label, le asigna el segundo elemento de classNames si que tiene
        switchColor: PropTypes.string, // Color del switch activo, por defecto es #20a8d8
        switchRight: PropTypes.bool, // Alinea el switch a la derecha, por defecto esta a la izquierda

        //Estilos clase filled-in
        spanStyle: PropTypes.bool, //si es true asigna un span abajo del input y agrega la clase filled-in al input


        classNames: PropTypes.arrayOf(PropTypes.string), //estilos de Columnas - array de 2 elementos string [class_col_label, class_col_input]

        // tamaño de columnas bootstrap - array de 2 elementos integer [col_label, col_input] - default [12, 12]
        xs: PropTypes.arrayOf(String),
        sm: PropTypes.arrayOf(String),
        md: PropTypes.arrayOf(String),
        lg: PropTypes.arrayOf(String),
        xl: PropTypes.arrayOf(String),

        error: PropTypes.any,
    }

    getError() {
		let error = this.props.error;
		if (typeof (error) == 'function') error = error();
		if (error) {
			return error.map(x => x.detail).join(' ');
		} else {
			return null;
		}
	}


    render() {
        const { classNames, xs, sm, md, lg, xl, value, label, onChange, labelDerecha, disabled, switchStyle, switchColor, onlySwitch, switchRight, checkmarkOnSwitch, spanStyle } = this.props;
        let error = this.getError();

        if(!switchStyle && !spanStyle){
            return (
                <Fragment>
                    {!onlySwitch ?
                    <Row className={"mt-sm-1"}>
                        <Col className={`${classNames && classNames.length > 0 ? classNames[0] : ""} ${xs && xs[1] == 0 ? "d-none" : ""}`}
                            xs={(xs ? xs[0] : 12)} sm={(sm ? sm[0] : null)} md={(md ? md[0] : null)} lg={(lg ? lg[0] : null)} xl={(xl ? xl[0] : null)}
                            onClick={() => (!labelDerecha && !disabled) ? onChange(!value) : null}
                        >
                            {(!labelDerecha) &&
                                <Label>{label}</Label>}
                        </Col>
                        <Col className={`${classNames && classNames.length > 0 ? classNames[1] : ""} ${xs && xs[1] == 0 ? "d-none" : ""}`}
                            xs={(xs ? xs[1] : 12)} sm={(sm ? sm[1] : null)} md={(md ? md[1] : null)} lg={(lg ? lg[1] : null)} xl={(xl ? xl[1] : null)}
                            onClick={() => (!disabled) ? onChange(!value) : null}
                        >
                            <input type="checkbox" disabled={disabled} className="mt-2" checked={value} onChange={(e) => {}}/>
                            {(labelDerecha) &&
                                <label className="ml-2" htmlFor="checkinp">{label}</label>}
                            <FormFeedback className={(error ? "d-block" : "")}>{error}</FormFeedback>
                        </Col>
                    </Row>
                    :
                    <Row>
                        <Col className={`${classNames && classNames.length > 0 ? classNames[1] : ""} ${xs && xs[1] == 0 ? "d-none" : ""}`}
                            xs={(xs ? xs[1] : 12)} sm={(sm ? sm[1] : null)} md={(md ? md[1] : null)} lg={(lg ? lg[1] : null)} xl={(xl ? xl[1] : null)}
                            onClick={() => (!disabled) ? onChange(!value) : null}
                        >
                            <input type="checkbox" disabled={disabled} className="mt-2" checked={value} onChange={(e) => {}}/>
                            {(labelDerecha) &&
                                <label className="ml-2" htmlFor="checkinp">{label}</label>}
                            <FormFeedback className={(error ? "d-block" : "")}>{error}</FormFeedback>
                        </Col>
                    </Row>}
                </Fragment>

            );
        }else if(switchStyle && !spanStyle){
            return (
                <Fragment>
                    {!onlySwitch ?
                    <Row className={"mt-sm-1"}>
                        <Col className={classNames && classNames.length > 0 ? classNames[0] : null}
                            xs={(xs ? xs[0] : 12)} sm={(sm ? sm[0] : null)} md={(md ? md[0] : null)} lg={(lg ? lg[0] : null)} xl={(xl ? xl[0] : null)}
                            onClick={() => (!labelDerecha && !disabled) ? onChange(!value) : null}>
                            {(!labelDerecha) &&
                                <Label>{label}</Label>}
                        </Col>
                        <Col className={classNames && classNames.length > 1 ? classNames[1] : null}
                            xs={(xs ? xs[1] : 12)} sm={(sm ? sm[1] : null)} md={(md ? md[1] : null)} lg={(lg ? lg[1] : null)} xl={(xl ? xl[1] : null)}
                            onClick={() => (!disabled) ? onChange(!value) : null}>
                            <div className={"switch mt-2"} style={{marginTop: "0px", float: (switchRight ? 'right' : 'left')}}>
                                <input type="checkbox" id="checkTable" onChange={(e) => {}} disabled={disabled} checked={value}/>
                                <span className={checkmarkOnSwitch ? "checkmark switch-slider round" : "switch-slider round"}
                                        style={{backgroundColor: (value) ? (switchColor ? switchColor : '#20a8d8') : '#999999'}}/>
                            </div>
                            {(labelDerecha) &&
                                <label className="ml-2" htmlFor="checkinp">{label}</label>}
                            <FormFeedback className={(error ? "d-block" : "")}>{error}</FormFeedback>
                        </Col>
                    </Row>
                    :
                    <Row className={"mt-sm-1"}>
                        <Col className={classNames && classNames.length > 1 ? classNames[1] : null}>
                            <div className={"switch mt-2"}
                                style={{marginTop: "0px", float: (switchRight ? 'right' : 'left')}}
                                onClick={() => (!disabled) ? onChange(!value) : null}
                            >
                                <input type="checkbox" id="checkTable" onChange={(e) => {}} disabled={disabled} checked={value}/>
                                <span className={checkmarkOnSwitch ? "checkmark switch-slider round" : "switch-slider round"}
                                        style={{backgroundColor: (value) ? (switchColor ? switchColor : '#20a8d8') : '#999999'}}/>
                            </div>
                            <FormFeedback className={(error ? "d-block" : "")}>{error}</FormFeedback>
                        </Col>
                    </Row>}
                </Fragment>
            );
        }else {
            return (
                <Fragment>
                {!onlySwitch ?
                    <Row className={"mt-sm-1"}>
                        <Col className={classNames && classNames.length > 0 ? classNames[0] : null}
                            xs={(xs ? xs[0] : 12)} sm={(sm ? sm[0] : null)} md={(md ? md[0] : null)} lg={(lg ? lg[0] : null)} xl={(xl ? xl[0] : null)}
                            onClick={() => (!labelDerecha && !disabled) ? onChange(!value) : null}
                        >
                            {(!labelDerecha) &&
                                <Label>{label}</Label>}
                        </Col>
                        <Col className={classNames && classNames.length > 1 ? classNames[1] : null}
                            xs={(xs ? xs[1] : 12)} sm={(sm ? sm[1] : null)} md={(md ? md[1] : null)} lg={(lg ? lg[1] : null)} xl={(xl ? xl[1] : null)}
                            onClick={() => (!disabled) ? onChange(!value) : null}
                        >
                            <input type="checkbox" disabled={disabled} className=" filled-in" checked={value} onChange={(e) => {}}/>
                            <span className="mt-2" >{(labelDerecha) && label}</span>
                            <FormFeedback className={(error ? "d-block" : "")}>{error}</FormFeedback>
                        </Col>
                    </Row>
                :
                    <Row className={"mt-sm-1"}>
                        <Col className={classNames && classNames.length > 1 ? classNames[1] : null}
                            xs={(xs ? xs[1] : 12)} sm={(sm ? sm[1] : null)} md={(md ? md[1] : null)} lg={(lg ? lg[1] : null)} xl={(xl ? xl[1] : null)}
                            onClick={() => (!disabled) ? onChange(!value) : null}
                        >
                            <input type="checkbox" disabled={disabled} className=" filled-in" checked={value} onChange={(e) => {}}/>
                            <span className="mt-2" >{(labelDerecha) && label}</span>
                            <FormFeedback className={(error ? "d-block" : "")}>{error}</FormFeedback>
                        </Col>
                    </Row>}
                </Fragment>
            );
        }
    }
}

export default ParadigmaCheckBoxInput;



// WEBPACK FOOTER //
// ./src/components/ParadigmaCheckboxInput/ParadigmaCheckBoxInput.js